import { Suspense } from 'react';
import Container from '@/components/Container';
import { LoadingContainer } from '../reporting-tools/components/loading-container';
import { useRoot } from './hooks/useRoot';
import { InviteUsers } from './components/invite-users';
import { useStaffList } from './hooks/useStaffList';
import { AllSchoolUsersList } from './components/all-users-list';
import { AdminTabs, AdminTabsEnum } from '@/components/AdminTabs';

export const ManageStaff = () => {
  const { page } = useRoot();
  const { staff, currentPage, totalPages, loading, refetch, handlePageChange } = useStaffList({
    pageSize: 10,
  });

  const hasUsers = (staff?.length ?? 0) > 0;

  if (loading) {
    return <LoadingContainer title="Loading manage staff..." />;
  }

  return (
    <Container className="!mt-sh-60">
      <div className="col-span-12 flex flex-col items-start">
        <AdminTabs activeTab={AdminTabsEnum.ManageStaff} />
      </div>
      {!hasUsers && (
        <div className="col-span-12 md:col-span-6">
          <div role="note" className="mt-4 rounded-2xl border border-blue-100 bg-blue-50 px-5 py-5 shadow-sm">
            <p className="text-sh-xs font-bold leading-8 text-black-100">{page?.staffEmptyState?.title}</p>
            <p className="mt-2 text-sh-xs text-black">{page?.staffEmptyState?.description}</p>
          </div>
        </div>
      )}
      <div className="col-span-12">
        <h1 className="font-cadiz text-sh-28-32 font-bold">{page?.title}</h1>
        <p className="mt-2 text-sh-xs text-black">{page?.description}</p>
        {hasUsers && (
          <AllSchoolUsersList
            title={page?.staffListTitle || ''}
            staff={staff}
            totalPages={totalPages}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        )}
        <InviteUsers refetch={refetch} />
      </div>
    </Container>
  );
};

export const ManageStaffScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading manage staff..." />}>
      <ManageStaff />
    </Suspense>
  );
};
